import React from 'react';

import ProcessDetails, {
  ProcessDetailsProps,
} from '~/components/Details/ProcessDetails';

import { Container } from './styles';

const MainInstanceDetails: React.FC<ProcessDetailsProps> = (props) => (
  <Container>
    <ProcessDetails {...props} />
  </Container>
);

export default MainInstanceDetails;
